// @ts-nocheck
import styled from 'styled-components';
import type { StatelessFunctionalComponent } from 'react';
import { getTheme } from 'settings/theme/index';
import { TABLET_WIDTH, TABLET_SMALL_WIDTH } from 'commons/constants';
import { Link } from 'react-router-dom';

const {
  palette: { primary },
  noodera: { fontTypes, spacing },
} = getTheme();
export const LinkContainer: StatelessFunctionalComponent<any> = styled.div`
  height: 52px;
  padding: ${spacing.x5} 0 0 ${spacing.x5};
  @media only screen and (min-width: ${TABLET_WIDTH}px) {
    height: 52px;
    padding: ${spacing.x5} 0;
  }
`;
export const StyledLink = styled(Link)`
  ${fontTypes.font5Medium};
  color: ${primary.hundred};
  &:hover {
    color: ${primary.hundred};
  }
`;
export const FilterContainer: StatelessFunctionalComponent<any> = styled.div`
  display: flex;
  flex-wrap: wrap;
  row-gap: 10px;
  column-gap: ${spacing.x7};
  padding: ${spacing.x5};
  margin-top: ${spacing.x4};

  @media only screen and (min-width: ${TABLET_SMALL_WIDTH}px) {
    padding: ${spacing.x5} 0;
  }

  @media only screen and (min-width: ${TABLET_WIDTH}px) {
    margin-top: ${spacing.x2};
  }
`;
